// extracted by mini-css-extract-plugin
export var auto = "_2u-1";
export var spinner = "_2u-0";